const PENDING_RETURN_PATH_KEY = 'pending_return_path';

/** Record the route the user originally requested (e.g. a tenant-filtered
 *  invoices deep link) so the OAuth2 callback can send them back there after
 *  login instead of a hardcoded dashboard. */
export const recordPendingLoginReturn = (path: string): void => {
  sessionStorage.setItem(PENDING_RETURN_PATH_KEY, path);
};

export const getPendingLoginReturn = (): string | null =>
  sessionStorage.getItem(PENDING_RETURN_PATH_KEY);

export const clearPendingLoginReturn = (): void => {
  sessionStorage.removeItem(PENDING_RETURN_PATH_KEY);
};